// @flow
import classNames from 'classnames';
import React from 'react';
import { DateUtil } from 'utils/DateUtil';
import type { Venue } from 'types/event';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import useEventUpdater from 'hooks/useEventUpdater';
// eslint-disable-next-line
import styles from "./styles.scss";

const MAX_EVENT_DATES = 3;

export const EventVenueCard = ({
  venue,
  className,
  type,
  filteredDates,
}: {
  venue: Venue,
  className?: string,
  type?: string,
}) => {
  const eventDates = venue.eventDates;
  const countryCode = CURRENT_COUNTRY_CODE === '+1' ? 'USA' : 'INDIA';
  const validEventDates = useEventUpdater(eventDates, countryCode, false);
  const containerClass = classNames('venue-container', className);
  let datesToSort = type === 'banner' ? filteredDates : validEventDates;
  const sortedEventDates = datesToSort.sort(function(a, b) {
    if (type === 'banner') {
      return new Date(a.concert_date) - new Date(b.concert_date);
    } else return new Date(a.date) - new Date(b.date);
  });

  const slicedDates = sortedEventDates.slice(0, MAX_EVENT_DATES);
  const eventDatesCount =
    type === 'banner' ? sortedEventDates.length : validEventDates.length;
  return (
    <div className={containerClass}>
      <div className={'location'}>
        <h3>{venue.name}</h3>
        {type === 'banner' ? (
          venue.location && <h3>{venue.location}</h3>
        ) : (
          <span>{venue.location}</span>
        )}
      </div>
      {
        type === 'banner' && filteredDates?.length == 0 ? 
        (<div className='event-dates'>
          <h4>Event Bookings Closed</h4> 
        </div> ) : null
      }
      <div className={'event-dates'}>
        {slicedDates.map((eventDate, idx) => {
          if (className === 'upcoming-events-card') {
            return (
              <h4 key={idx} className={'event-date'}>
                {DateUtil.getDisplayDateFromISOString(eventDate.date)}
                <small>&nbsp;at&nbsp;</small>
                {eventDate.startTime}{' '}
                {eventDate.endTime ? `to ${eventDate.endTime}` : 'onwards'}
              </h4>
            );
          } else {
            return (
              <h4 key={idx}>
                {DateUtil.getEventDetailBannerDate(
                  eventDate.concert_date,
                  eventDate.start_time
                )}
              </h4>
            );
          }
        })}
        {eventDatesCount > MAX_EVENT_DATES && (
          <span>
            and {eventDatesCount - MAX_EVENT_DATES} more upcoming concerts
          </span>
        )}
      </div>
    </div>
  );
};
